module.exports = __webpack_public_path__ + "static/img/10areaA_10.581bff6.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/10areaA_10.png
// module id = 796
// module chunks = 1